import { cva } from 'class-variance-authority';

const inputVariants = cva(
  'flex rounded-md shadow-none border border-border-base bg-background leading-tight text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-grey-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        /**
         * To be used for edge cases where the input needs to be a different size and fully
         * customisable.
         */
        none: '',
        /**
         * To be used for most inputs across the application.
         */
        default: 'w-full h-12 pl-3 pr-12 min-h-12',
        inline: 'inline h-8 rounded-lg text-center w-[38px] disabled:w-[38px]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export { inputVariants };
